/**
 * Export an array of objects as a CSV file download.
 * @param {string} filename - Name of the downloaded file (e.g., "reservations.csv")
 * @param {Array<Object>} data - Array of flat objects
 * @param {Array<{key: string, label: string}>} columns - Column definitions
 */
export const exportToCsv = (filename, data, columns) => {
  if (!data?.length) return;

  const header = columns.map((c) => `"${c.label}"`).join(",");
  const rows = data.map((row, rowIndex) =>
    columns
      .map((c) => {
        let val = typeof c.key === "function" ? c.key(row, rowIndex) : row[c.key];
        if (val === null || val === undefined) val = "";
        // Escape double quotes
        val = String(val).replace(/"/g, '""');
        return `"${val}"`;
      })
      .join(",")
  );

  const csv = [header, ...rows].join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
